/**
 * Collaborate status tones — tickets-page StatusPill look (soft fill + ink, no dot).
 */
export type ThreadStatusKey = "pending" | "approved" | "rejected";

export const STATUS_META: Record<
  ThreadStatusKey,
  { label: string; bg: string; fg: string; /** @deprecated unused — kept for quote accents */ dot: string }
> = {
  pending: {
    label: "Pending",
    bg: "var(--warn-soft)",
    fg: "var(--warn)",
    dot: "var(--warn)",
  },
  approved: {
    label: "Approved",
    bg: "var(--ok-soft)",
    fg: "var(--ok)",
    dot: "var(--ok)",
  },
  rejected: {
    label: "Rejected",
    bg: "var(--bad-soft)",
    fg: "var(--bad)",
    dot: "var(--bad)",
  },
};
